export default "__VITE_ASSET__sF2TARIx__"